import React, { Component } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/footer';
import Home from '../Components/Historia/Home';
class Quimicos extends Component{
    render(){
        return(
            <div>
                <Header/>
                <Home />
                {/* <Footer show="history" history={this.props.history}/> */}
            </div>
        )
    }
}
export default Quimicos;